/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import {
  GET_XERO_CONSENT_URL_GQL,
  SET_XERO_ACCESS_TOKEN_GQL,
  GET_XERO_CREDITCARDACCOUNTLIST_GQL,
  SET_CREATE_XERO_ACCOUNT_GQL,
  GET_XERO_CATEGORYLIST_GQL,
  SET_SYNC_XERO_CATEGORIES_GQL,
  GET_REC_SEL_XERO_CRE_CARD_ACC_GQL,
  SET_XERO_POST_TRANSACTIONS_GQL,
  SET_XERO_UPDATE_TRANSACTIONS_GQL,
  GET_XERO_CON_ERRS_GQL,
  SET_XERO_POST_JOURNAL_ENTRIES_GQL,
} from '@/graphql/xero.gql';


export default {
  namespaced: true,

  state: {
    xeroConsentUrl: null,
    xeroAccessToken: null,
    xeroCcAccountList: null,
    createdAccount: null,
    xeroCategoryList: null,
    syncedXeroCategories: null,
    recentlySelectedCreditCardAccount: null,
    syncedXeroTransactions: null,
    xeroConnectionError: null,
    syncedXeroJournalEntries: null,

  },
  mutations: {
    GET_XERO_CONSENT_URL(state, payload) {
      state.xeroConsentUrl = payload;
    },
    SET_XERO_ACCESS_TOKEN(state, payload) {
      state.xeroAccessToken = payload;
    },
    GET_XERO_CREDITCARDACCOUNTLIST(state, payload) {
      state.xeroCcAccountList = payload;
    },
    SET_CREATE_XERO_ACCOUNT(state, payload) {
      state.createdAccount = payload;
    },
    GET_XERO_CATEGORYLIST(state, payload) {
      state.xeroCategoryList = payload;
    },
    SET_SYNC_XERO_CATEGORIES(state, payload) {
      state.syncedXeroCategories = payload;
    },
    GET_REC_SEL_XERO_CRE_CARD_ACC(state, payload) {
      state.recentlySelectedCreditCardAccount = payload;
    },
    SET_SYNC_XERO_TRAN(state, payload) {
      state.syncedXeroTransactions = payload;
    },
    GET_XERO_CON_ERRS(state, payload) {
      state.xeroConnectionError = payload;
    },
    SET_SYNC_XERO_JE(state, payload) {
      state.syncedXeroJournalEntries = payload;
    },
  },

  actions: {
    async getXeroConsentUrl({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: GET_XERO_CONSENT_URL_GQL,
          fetchPolicy: 'no-cache',
          variables: payload,
        })
        .then(({ data }) => {
          commit('GET_XERO_CONSENT_URL', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    insertAccessToken({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SET_XERO_ACCESS_TOKEN_GQL,
          variables: {
            authCode: payload.authCode,
            state: payload.state,
            userId: payload.userId,
            companyId: payload.companyId,
            xeroReturnUrl: payload.xeroReturnUrl,
          },
        })
        .then(({ data }) => {
          console.log(data);
          commit('SET_XERO_ACCESS_TOKEN', data.getXeroTokenData);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getXeroCreditCardAccountList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: GET_XERO_CREDITCARDACCOUNTLIST_GQL,
          variables: {
            id: payload.id,
            refreshToken: payload.refreshToken,
            accessToken: payload.accessToken,
            tenantId: payload.tenantId,
          },
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          console.log(data);
          commit('GET_XERO_CREDITCARDACCOUNTLIST', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async createXeroCreditCardAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: SET_CREATE_XERO_ACCOUNT_GQL,
          variables: {
            xeroTblId: payload.xeroTblId,
            userId: payload.userId,
            companyId: payload.companyId,
            accountIdStr: payload.selectedAccountId,
            accountName: payload.selectedAccountName,
            code: payload.selectedAccountCode,
          },
        })
        .then(({ data }) => {
          console.log(data);
          commit('SET_CREATE_XERO_ACCOUNT', data.createXeroCreditCardAccount.id);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getXeroCategoryList({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .mutate({
          mutation: GET_XERO_CATEGORYLIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_XERO_CATEGORYLIST', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async syncXeroCategories({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      await apolloClient
        .mutate({
          mutation: SET_SYNC_XERO_CATEGORIES_GQL,
          variables: {
            companyId: payload.companyId,
          },
        }).then((syncXeroCategoriesData) => {
          commit('SET_SYNC_XERO_CATEGORIES', syncXeroCategoriesData.data.syncXeroCategories);
          commit('shared/SET_LOADING', false, { root: true });
        }).catch(syncXeroCategoriesErr => {
          commit('SET_SYNC_XERO_CATEGORIES',{status: "failure", error: syncXeroCategoriesErr.message});          
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getRecentlySelectedCreditCardAccount({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_REC_SEL_XERO_CRE_CARD_ACC_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_REC_SEL_XERO_CRE_CARD_ACC', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async syncXeroTransaction({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: SET_XERO_POST_TRANSACTIONS_GQL,
          variables: payload,
        })
        .then((dataPostTran) => {
          apolloClient
            .mutate({
              mutation: SET_XERO_UPDATE_TRANSACTIONS_GQL,
              variables: payload,
            })
            .then((dataUpdateTran) => {
              const syncTranRes = {
                postSuccTran: dataPostTran.data.postXeroTransactions.successfulTransactions,
                postFailedTran: dataPostTran.data.postXeroTransactions.failedTransactions,
                updateSuccTran: dataUpdateTran.data.updateXeroTransactions.successfulTransactions,
                updateFailedTran: dataUpdateTran.data.updateXeroTransactions.failedTransactions,
              };
              commit('SET_SYNC_XERO_TRAN', syncTranRes);
              commit('shared/SET_LOADING', false, { root: true });
            });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async syncXeroJournalEntries({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });
      apolloClient
        .mutate({
          mutation: SET_XERO_POST_JOURNAL_ENTRIES_GQL,
          variables: payload,
        })
        .then((postJE) => {
          console.log('JE response after sync',postJE.data);
          const syncJERes = {
            postSuccTran: postJE.data.postQuickBookJournalEntries.successfulTransactions,
            postFailedTran: postJE.data.postQuickBookJournalEntries.failedTransactions,
          //  updateSuccTran: updateJE.data.updateQuickBookJournalEntries.successfulTransactions,
          //  updateFailedTran: updateJE.data.updateQuickBookJournalEntries.failedTransactions,
          };
          commit('SET_SYNC_XERO_JE', syncJERes);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
    async getXeroConnectionError({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_XERO_CON_ERRS_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then(({ data }) => {
          commit('GET_XERO_CON_ERRS', data);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, { root: true });
        });
    },
  },


  getters: {
    xeroConsentUrl: state => state.xeroConsentUrl,
    xeroAccessToken: state => state.xeroAccessToken,
    xeroCcAccountList: state => state.xeroCcAccountList,
    createdAccount: state => state.createdAccount,
    xeroCategoryList: state => state.xeroCategoryList,
    syncedXeroCategories: state => state.syncedXeroCategories,
    recentlySelectedCreditCardAccount: state => state.recentlySelectedCreditCardAccount,
    syncedXeroTransactions: state => state.syncedXeroTransactions,
    xeroConnectionError: state => state.xeroConnectionError,
    syncedXeroJournalEntries: state => state.syncedXeroJournalEntries,

  },
};
